import store from '@/state/store';
import { login } from '@/api/auth';
import authenticationSlice from '@/state/authentication.slice';
import { AuthenticationStatus } from '@/contracts';
import { LoginByEmailRequest, LoginByPhoneRequest } from '@bimdata/definitions/dto';
import { AuthErrorCodes, VerificationErrorCodes } from '@bimdata/definitions/errors';
import { logout } from '.';
import { initSession } from '@/loaders/profile';
import { handleError, reportError } from '../common';
import { Logger } from '@bimdata/client';
import t from '@/utils/translate';

export default async (data: LoginByEmailRequest | LoginByPhoneRequest) => {
  const { authentication } = store.getState();
  if (
    authentication.status !== AuthenticationStatus.PENDING
    && authentication.status !== AuthenticationStatus.UNAUTHORIZED
  ) {
    Logger.warn(t('authentication.message.invalidMethod'));
    return;
  }
  logout();
  store.dispatch(authenticationSlice.actions.startLogin());
  try {
    const result = await login(data);
    if (typeof result === 'string') {
      store.dispatch(authenticationSlice.actions.waitPhoneConfirmation(result));
    } else {
      store.dispatch(authenticationSlice.actions.finishLogin());

      await initSession();
    }
  } catch (error) {
    if (
      error.code === 401
      && error.exceptionCode === AuthErrorCodes.INVALID_CREDENTIALS
    ) {
        store.dispatch(authenticationSlice.actions.waitPhoneConfirmation('none'));
        return;
    }

    store.dispatch(authenticationSlice.actions.reset());

    if (
      error.code === 403
      && error.exceptionCode === VerificationErrorCodes.UNAVAILABLE_VERIFICATION_METHOD
    ) {
      reportError(error, t('authentication.error.phoneNotConfirmed', { phone: (data as LoginByPhoneRequest).phone }));
      return;
    }

    handleError(error);
  }
};
